import { Button, Card } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import moment from "moment";
import paymentSuccess from "../../assets/svg/payment-successful.svg";
import paySuccess from "../../assets/svg/pay-success.svg";

const Confirmation = () => {
  const navigate = useNavigate();
  const subscription = useSelector(
    (state) => state.CommonReducer.subscriptionaccountInfo
  );

  return (
    <Card className="mt20">
      <img src={paymentSuccess} alt="" className="position-relative" />
      <div className="d-flex flex-column align-items-center justify-content-center payment-success">
        <img src={paySuccess} alt="" />
        <div className="mt10 fw-bold heading16px">Payment Successful</div>
      </div>
      <div className="d-flex align-items-center justify-content-center">
        <div className="text-center mt10" style={{ maxWidth: 400 }}>
          Thankyou for choosing us and processing your most recent payment. Your
          premium subscription will expire on{" "}
          {moment(subscription?.validTo).format("MMMM DD, YYYY")}.
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <Button
          type="primary"
          className="theme-btn mt30"
          onClick={() => {
            navigate("/dashboard-view");
          }}
        >
          Go to Dashboard
          <i className="fas fs-12 fa-arrow-right"></i>
        </Button>
      </div>
    </Card>
  );
};

export default Confirmation;
